import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import Papa, { LocalFile, ParseLocalConfig } from "papaparse";
import { FileUploadHandlerEvent } from "primereact/fileupload";
import { useState } from "react";
import { T } from "services/lang/LanguageService";

export type ParseResultDataWithHeaders = Record<string, string | number | boolean | null>;
export type ParseResultDataWithoutHeaders = (string | number | boolean | null)[];
export type ParseResultData = ParseResultDataWithHeaders | ParseResultDataWithoutHeaders;

function useCsvReader(config?: ParseLocalConfig<ParseResultData, LocalFile>) {
  const [data, setData] = useState<ParseResultData[]>([]);
  const [headers, setHeaders] = useState<string[]>([]);

  const handleFileChange = (event: FileUploadHandlerEvent) => {
    const file = event.files?.[0];
    if (file) {
      Papa.parse<ParseResultData>(file, {
        header: true,
        skipEmptyLines: true,
        dynamicTyping: true,
        complete: results => {
          setHeaders(Object.keys(results.data[0]));
          setData(results.data);
        },
        error: error => {
          easasAlert({
            severity: "error",
            summary: T("alert.error-parsing-file"),
            detail: error.message,
          });
        },
        ...config,
      });
    }
    event.options.clear();
  };

  return { handleFileChange, data, headers } as const;
}

export default useCsvReader;
